import clsx from 'clsx'
import React from 'react'

type Props = {
  className?: string
  children?: any
  style?: any
  fullWidth?: boolean
}

const TableWrapper: React.FC<Props> = ({className, children, style, fullWidth = true}) => {
  return (
    <div
      className={clsx('card', className, {
        'table-content': fullWidth,
      })}
      style={style}
    >
      {children}
    </div>
  )
}

export {TableWrapper}
